export const VIEW_JOB_LINK =
  "https://careers.pingcap.com/#/?anchorName=default_banner&sourceToken="

export const WHY_CHOOSE_US = {
  title: "为什么选择 PingCAP",
  features: [
    {
      icon: "/join-us/67.团队.svg",
      description: "开放自由的团队",
    },
    {
      icon: "/join-us/72.创意.svg",
      description: "创新进取的文化",
    },
    {
      icon: "/join-us/69.增长.svg",
      description: "快速成长的机会",
    },
  ],
}

export const THE_QUALITIES_WE_NEED = {
  title: "我们期望你具备的特质",
  features: [
    {
      icon: "/join-us/70.热爱.svg",
      description: "聪明+热爱+自我驱动",
    },
    {
      icon: "/join-us/43.成就.svg",
      description: "永远把事情做好",
    },
    {
      icon: "/join-us/76.活动.svg",
      description: "刨根问底的精神",
    },
    {
      icon: "/join-us/39.查看.svg",
      description: "对世界充满好奇\n和改造它的勇气",
    },
  ],
}

export const VIEW_OPEN_POSITIONS = {
  title: "查看在招职位",
  socialRecruitment: {
    title: "社会招聘",
    subtitle: "面向社会广大优秀人才",
  },
  campusRecruitment: {
    title: "校园招聘",
    subtitle: "面向应届毕业生与实习生",
  },
}

export const SOCIAL_RECRUITMENT_LINK =
  "https://careers.pingcap.com/#/?anchorName=default_joblist&sourceToken= "

export const CAMPUS_RECRUITMENT_LINK =
  "https://campus.pingcap.com/campus_apply/pingcap/39951/#/?anchorName=default_joblist&sourceToken="

export const FAMOUS_ENTERPRISES_LINK = "https://tidb-jobs.pingcap.com/#/"
